import React, { useState } from 'react';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import { motion, AnimatePresence } from 'framer-motion';

const galleryImages = [
  { id: 1, category: 'natural', url: 'https://plus.unsplash.com/premium_photo-1661393486358-58da5572e516?auto=format&fit=crop&q=80&w=600' },
  { id: 2, category: 'volume', url: 'https://images.unsplash.com/photo-1639629509821-c54cdd984227?auto=format&fit=crop&q=80&w=600' },
  { id: 3, category: 'hybrid', url: 'https://images.unsplash.com/photo-1683719312734-e31de63957ab?auto=format&fit=crop&q=80&w=600' },
  { id: 4, category: 'mega', url: 'https://images.unsplash.com/photo-1528047128849-2382ff646073?auto=format&fit=crop&q=80&w=600' },
  { id: 5, category: 'lift', url: 'https://plus.unsplash.com/premium_photo-1661502931069-1d0078d82f4d?auto=format&fit=crop&q=80&w=600' },
  { id: 6, category: 'natural', url: 'https://plus.unsplash.com/premium_photo-1664908322742-a64ca0b63b16?auto=format&fit=crop&q=80&w=600' },
  { id: 7, category: 'natural', url: 'https://images.unsplash.com/photo-1609978204750-d5018aa878d3?auto=format&fit=crop&q=80&w=600' },
  { id: 8, category: 'volume', url: 'https://images.unsplash.com/photo-1589523101416-3b235a915408?auto=format&fit=crop&q=80&w=600' },
];

const categories = [
  { id: 'all', label: 'All Work' },
  { id: 'natural', label: 'Classic / Natural' },
  { id: 'hybrid', label: 'Hybrid' },
  { id: 'volume', label: 'Volume' },
  { id: 'mega', label: 'Mega Volume' },
  { id: 'lift', label: 'Lash Lift' }
];

const Gallery = () => {
  const [filter, setFilter] = useState('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <div className="bg-white min-h-screen">
      <PageHeader title="Our Portfolio" bgImage="https://images.unsplash.com/photo-1521590832167-7bfcbaa6362d?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-7xl py-24">
        <SectionHeading title="Studio Results" subtitle="Before & After" />
        
        {/* Filter Buttons */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          {categories.map(cat => (
            <button
              key={cat.id}
              onClick={() => setFilter(cat.id)}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                filter === cat.id 
                  ? 'bg-veloura-accent text-white shadow-md' 
                  : 'bg-veloura-bg text-veloura-muted hover:bg-veloura-primary/50'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <AnimatePresence>
            {filteredImages.map((img) => (
              <motion.div
                key={img.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                className="aspect-square rounded-2xl overflow-hidden group relative cursor-pointer"
              >
                <img src={img.url} alt={`Lash styling ${img.category}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-veloura-text/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <span className="text-white font-serif text-xl tracking-wider uppercase">{img.category}</span>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

export default Gallery;